var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',_vm._l((_vm.routerVal),function(list){return _c('div',{staticClass:"indexButton_baoming",on:{"click":function($event){return _vm.jump(list.active)}}},[_vm._v(_vm._s(list.name))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }